import propTypes from 'prop-types';
import React from 'react';
import Img from 'react-cool-img';
import LinesEllipsis from 'react-lines-ellipsis';
import {Link} from 'react-router-dom';

import errorImage from '../../../public/img/404.jpeg';
import loadingImage from '../../../public/img/420.jpeg';
import track from '../../telemetry';

const FriendsTop = ({ friendsTop, getCurrentUser }) =>
  friendsTop.map((friend) => (
    <React.Fragment key={friendsTop.indexOf(friend)}>
      <Link
        to={friend[1].urlAddress}
        className="friends-top-icon"
        onClick={() => {
          track('top_friend_clicked');
          getCurrentUser();
        }}
      >
        <LinesEllipsis
          className="friends-top-icon-name"
          text={`${friend[1].description.firstName} ${friend[1].description.lastName} `}
          ellipsis="... "
          basedOn="letters"
        />
        <Img
          className="friends-top-icon-img"
          src={friend[1].description.pic}
          placeholder={loadingImage}
          error={errorImage}
          lazy
          cache
          alt="top friend profile icon"
        />
      </Link>
    </React.Fragment>
  ));

FriendsTop.defaultProps = {
  friendsTop: [],
};

FriendsTop.propTypes = {
  friendsTop: propTypes.oneOfType([propTypes.array]),
};

export default FriendsTop;
